import React from "react";
import SharedHelmet from "./Helmet";
const TITLE = "About Do Calculate";
const DESCRIPTION = "Do Calculate is the leading  platform offering over 2000 free online calculators to help you perform calculations quickly and accurately in various fields such as finance, fitness, health, mathematics, physics, and more.";
const KEYWORDS = "Do Calculate, calculator, free calculator, mathematics, finance, fitness, physics, calculations,  online calculator";
const OG_URL = "https://do-calculate.com/en/about/";
const About = () => {
  return (
    <div >
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="p-3 mb-2 bg-success text-white">
        <h1 style={{ fontSize: '24px', marginBottom: '15px' }}>
          <b>About Do Calculate</b>
        </h1>
      </div>
      <p style={{ lineHeight: '1.6' }}>
        Do Calculate is one of the largest platform specializing in providing over 2000 free online calculators. We offer a wide range of calculators that cover mathematics, finance, fitness, health, physics, and more. Our platform aims to facilitate quick and accurate calculations across various fields, with in-depth information available for each calculator.
        <br/>        More than 92% of our calculators are based on well-known formulas and equations from textbooks, such as the Body Mass Index (BMI) calculator, among others. If formulas are controversial, we provide results from all popular formulas, as seen in the Ideal Weight Calculator.
        <br/>        We exclusively focus on providing fast, comprehensive, convenient, and free online calculators across various domains. Our goal is to become the primary Arabic site that people turn to for quick calculations. Additionally, we believe that the internet should be a source of free information, so all our tools and services are entirely free and require no registration.
        <br/>        We have made a significant effort to ensure that all calculators function correctly. However, if you find any minor errors or have suggestions for improving our services, please let us know.
      </p>
      <hr />
      <div className="p-3 mb-2 bg-success text-white">
        <p style={{ lineHeight: '1.6' }}>
          If you have any inquiries, wish to request new calculators, or need to report an issue with one of the calculators, please contact us at:
          <br />
          <a href="mailto:info@do-calculate.com" style={{ color: 'white', textDecoration: 'underline' }}>info@do-calculate.com</a>
        </p>
      </div>
    </div>
  );
};
export default About;
